module.exports = __webpack_public_path__ + "1a00867991541c84451a8330f68a1a65.png";